/** @jsx h */
const Checkbox = ({ option, filterName, handleChange, pluginNamespace }) => {
  return (
    <li
      className={`search__filter-item ${
        option.selected ? 'search__filter-item-active' : ''
      }`}
    >
      <input
        id={`${filterName}-${option.value}`}
        className="sr-only"
        type="checkbox"
        name={`${pluginNamespace}[filter][]`}
        value={`${filterName}:${option.value}`}
        data-label={`${filterName}-${option.label}`}
        onChange={handleChange}
        checked={option.selected}
      />
      <label htmlFor={`${filterName}-${option.value}`}>
        {option.label} ({option.documentCount})
      </label>
    </li>
  );
};

export default Checkbox;
